const initialState = {
  osIdentifiers: {
    id: null,
    identifier1: null,
    identifier2: null,
    identifier3: null,
    identifier4: null,
    identifier5: null,
    identifier6: null,
  },
};

export default {
  ...initialState,
};
